import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ScrollToTop } from './components/layout/ScrollToTop';
import { LoadingSpinner } from './components/shared/LoadingSpinner';
import { NowHomePage } from './pages/NowHomePage';
const CategoryPage = lazy(() => import('./pages/CategoryPage').then(module => ({
  default: module.CategoryPage
})));
const CategoriesPage = lazy(() => import('./pages/CategoriesPage').then(module => ({
  default: module.CategoriesPage
})));
const CartPage = lazy(() => import('./pages/CartPage').then(module => ({
  default: module.CartPage
})));
const CheckoutPage = lazy(() => import('./pages/CheckoutPage').then(module => ({
  default: module.CheckoutPage
})));
const AccountPage = lazy(() => import('./pages/AccountPage').then(module => ({
  default: module.AccountPage
})));
const OffersPage = lazy(() => import('./pages/OffersPage').then(module => ({
  default: module.OffersPage
})));
const ProductDetailPage = lazy(() => import('./pages/ProductDetailPage').then(module => ({
  default: module.ProductDetailPage
})));
const PrescriptionPage = lazy(() => import('./pages/PrescriptionPage').then(module => ({
  default: module.PrescriptionPage
})));
const AllPrescriptionsPage = lazy(() => import('./pages/AllPrescriptionsPage').then(module => ({
  default: module.AllPrescriptionsPage
})));
const BMICalculatorPage = lazy(() => import('./pages/BMICalculatorPage').then(module => ({
  default: module.BMICalculatorPage
})));
const NutritionCalculatorPage = lazy(() => import('./pages/NutritionCalculatorPage').then(module => ({
  default: module.NutritionCalculatorPage
})));
const IngredientGlossaryPage = lazy(() => import('./pages/IngredientGlossaryPage').then(module => ({
  default: module.IngredientGlossaryPage
})));
const ThankYouPage = lazy(() => import('./pages/ThankYouPage').then(module => ({
  default: module.ThankYouPage
})));
const StoreLocatorPage = lazy(() => import('./pages/StoreLocatorPage').then(module => ({
  default: module.StoreLocatorPage
})));
const BrandsPage = lazy(() => import('./pages/BrandsPage').then(module => ({
  default: module.BrandsPage
})));
const BrandStorePage = lazy(() => import('./pages/BrandStorePage').then(module => ({
  default: module.BrandStorePage
})));
const ContactUs = lazy(() => import('./pages/ContactUs').then(module => ({
  default: module.ContactUs
})));
const AboutUs = lazy(() => import('./pages/AboutUs').then(module => ({
  default: module.AboutUs
})));
const FAQPage = lazy(() => import('./pages/FAQPage').then(module => ({
  default: module.FAQPage
})));
const PrivacyPolicyPage = lazy(() => import('./pages/PrivacyPolicyPage').then(module => ({
  default: module.PrivacyPolicyPage
})));
const TermsConditionsPage = lazy(() => import('./pages/TermsConditionsPage').then(module => ({
  default: module.TermsConditionsPage
})));
const ReturnPolicyPage = lazy(() => import('./pages/ReturnPolicyPage').then(module => ({
  default: module.ReturnPolicyPage
})));
const ShippingPolicyPage = lazy(() => import('./pages/ShippingPolicyPage').then(module => ({
  default: module.ShippingPolicyPage
})));
const ReportIssuePage = lazy(() => import('./pages/ReportIssuePage').then(module => ({
  default: module.ReportIssuePage
})));
const HelpCenterPage = lazy(() => import('./pages/HelpCenterPage').then(module => ({
  default: module.HelpCenterPage
})));
const TrackOrderPage = lazy(() => import('./pages/TrackOrderPage').then(module => ({
  default: module.TrackOrderPage
})));
const MedicineReminderPage = lazy(() => import('./pages/MedicineReminderPage').then(module => ({
  default: module.MedicineReminderPage
})));
const BundleBuilderPage = lazy(() => import('./pages/BundleBuilderPage').then(module => ({
  default: module.BundleBuilderPage
})));
const StackingGuidePage = lazy(() => import('./pages/StackingGuidePage').then(module => ({
  default: module.StackingGuidePage
})));
const QuizResultsPage = lazy(() => import('./pages/QuizResultsPage').then(module => ({
  default: module.QuizResultsPage
})));
const DoctorConsultationPage = lazy(() => import('./pages/DoctorConsultationPage').then(module => ({
  default: module.DoctorConsultationPage
})));
const PharmacistConsultationPage = lazy(() => import('./pages/PharmacistConsultationPage').then(module => ({
  default: module.PharmacistConsultationPage
})));
const RxHomePage = lazy(() => import('./pages/RxHomePage').then(module => ({
  default: module.RxHomePage
})));
const NowStorePage = lazy(() => import('./pages/NowStorePage').then(module => ({
  default: module.NowStorePage
})));
const MobileMenuPage = lazy(() => import('./pages/MobileMenuPage').then(module => ({
  default: module.MobileMenuPage
})));
export function AppRouter() {
  return <>
      <style data-id="element-0" data-mp="13uoygbc1r1f1">{`:root { --header-height-desktop: 162px !important; }`}</style>
      <BrowserRouter data-id="element-1" data-mp="2t8v24ggsgco9">
        <ScrollToTop data-id="element-2" data-mp="2t9mqb682384i" />
        <Suspense fallback={<LoadingSpinner data-id="element-4" data-mp="2y87ol03qzhqb" />} data-id="element-3" data-mp="2t70gezxp0gj4">
          <Routes data-id="element-5" data-mp="2y8g5r46wl97b">
            <Route path="/" element={<NowHomePage data-id="element-7" data-mp="2y63o6s5250us" />} data-id="element-6" data-mp="2y6wkez6e47yo" />
            <Route path="/menu" element={<MobileMenuPage data-id="element-9" data-mp="mlw3h4og0urf" />} data-id="element-8" data-mp="mkl0h72tnr1d" />
            <Route path="/categories" element={<CategoriesPage data-id="element-11" data-mp="hm1fp9zyslal" />} data-id="element-10" data-mp="ml4bs4xyvh6f" />
            <Route path="/category/:categoryName" element={<CategoryPage data-id="element-13" data-mp="hjx0vx0j21vj" />} data-id="element-12" data-mp="hmt1xu7o96o7" />
            <Route path="/brands" element={<BrandsPage data-id="element-15" data-mp="wc8mutkiuhvz" />} data-id="element-14" data-mp="wb5tmezq83cw" />
            <Route path="/brand/:brandSlug" element={<BrandStorePage data-id="element-17" data-mp="rjnuzxl6eev3" />} data-id="element-16" data-mp="wch0wosdrt8r" />
            <Route path="/cart" element={<CartPage data-id="element-19" data-mp="ri4dy4rp3zs9" />} data-id="element-18" data-mp="ricv48uupr99" />
            <Route path="/checkout" element={<CheckoutPage data-id="element-21" data-mp="15a16g9xa0bp6" />} data-id="element-20" data-mp="15asy59nr5pa6" />
            <Route path="/account" element={<AccountPage data-id="element-23" data-mp="11aa4rb67ob5v" />} data-id="element-22" data-mp="15d6tljmch3i9" />
            <Route path="/account/orders" element={<AccountPage data-id="element-25" data-mp="11c3c6sonezex" />} data-id="element-24" data-mp="118z2xgwbtdhe" />
            <Route path="/account/addresses" element={<AccountPage data-id="element-27" data-mp="1f905d0s8osyz" />} data-id="element-26" data-mp="1fa1prvv5artd" />
            <Route path="/account/wallet" element={<AccountPage data-id="element-29" data-mp="1aa5i9mn8oi92" />} data-id="element-28" data-mp="1aafdbon55flm" />
            <Route path="/account/points" element={<AccountPage data-id="element-31" data-mp="3h0mx54jygrwi" />} data-id="element-30" data-mp="1ab8b4044gurm" />
            <Route path="/account/wishlist" element={<AccountPage data-id="element-33" data-mp="3h2zcrb28qq6e" />} data-id="element-32" data-mp="3h1y1b5hbc1o5" />
            <Route path="/account/returns" element={<AccountPage data-id="element-35" data-mp="3c33i42ffob3i" />} data-id="element-34" data-mp="3c21wx54pe882" />
            <Route path="/account/coupons" element={<AccountPage data-id="element-37" data-mp="1fz6v3byq7x37" />} data-id="element-36" data-mp="3c3wkysb9uggd" />
            <Route path="/account/payment-requests" element={<AccountPage data-id="element-39" data-mp="1kxqhfdh8faw3" />} data-id="element-38" data-mp="1fzyqaloevssy" />
            <Route path="/account/payment-requests/:id" element={<AccountPage data-id="element-41" data-mp="1kzl6n3zjdp5z" />} data-id="element-40" data-mp="1kyrwdt1dchj3" />
            <Route path="/offers" element={<OffersPage data-id="element-43" data-mp="1oykasmdg1hwd" />} data-id="element-42" data-mp="1oytyu4exhezf" />
            <Route path="/product/:productId" element={<ProductDetailPage data-id="element-45" data-mp="1tyoqwbafwam2" />} data-id="element-44" data-mp="1p1g7y8hgw2jr" />
            <Route path="/prescription" element={<PrescriptionPage data-id="element-47" data-mp="1yxj673977h1f" />} data-id="element-46" data-mp="1tzzr614of08f" />
            <Route path="/prescription/history" element={<AllPrescriptionsPage data-id="element-49" data-mp="1yvf5eu6liy5d" />} data-id="element-48" data-mp="1ywgif4769upq" />
            <Route path="/prescriptions" element={<Navigate to="/prescription/history" replace data-id="element-51" data-mp="23v1jt6y5ukfr" />} data-id="element-50" data-mp="23w2xzkah3n1p" />
            <Route path="/rx" element={<RxHomePage data-id="element-53" data-mp="28om6w3y7tu06" />} data-id="element-52" data-mp="28n2r0egh1kyx" />
            <Route path="/health" element={<Navigate to="/rx" replace data-id="element-55" data-mp="2coo8ye7v4pfz" />} data-id="element-54" data-mp="28pfflagqitky" />
            <Route path="/now" element={<NowHomePage data-id="element-57" data-mp="2cqr0j2onyqmt" />} data-id="element-56" data-mp="2coelaxaaiudg" />
            <Route path="/now/store/:storeSlug" element={<NowStorePage data-id="element-59" data-mp="2hpu5yo8k2yvb" />} data-id="element-58" data-mp="2hoj1em7adn35" />
            <Route path="/rx2" element={<Navigate to="/prescription" replace data-id="element-61" data-mp="2mmatphbufb7v" />} data-id="element-60" data-mp="2mn3rvtwqksee" />
            <Route path="/doctor-consultation" element={<DoctorConsultationPage data-id="element-63" data-mp="2wrarhrez3gpp" />} data-id="element-62" data-mp="2mkzrvn1ykdje" />
            <Route path="/pharmacist-consultation" element={<PharmacistConsultationPage data-id="element-65" data-mp="2rren3r2d5n9m" />} data-id="element-64" data-mp="2wsc4i1fjuda2" />
            <Route path="/bmi-calculator" element={<BMICalculatorPage data-id="element-67" data-mp="2msuvpb503j9v" />} data-id="element-66" data-mp="2rqd1isnq1idn" />
            <Route path="/nutrition-calculator" element={<NutritionCalculatorPage data-id="element-69" data-mp="2muo7t5yduvp9" />} data-id="element-68" data-mp="2mtw9vohbclvt" />
            <Route path="/ingredient-glossary" element={<IngredientGlossaryPage data-id="element-71" data-mp="2it2ph532xp7o" />} data-id="element-70" data-mp="2is1c2tylcqms" />
            <Route path="/thank-you" element={<ThankYouPage data-id="element-73" data-mp="3fg7c13kkiuuq" />} data-id="element-72" data-mp="3fi1wyhvuamyt" />
            <Route path="/store-locator" element={<StoreLocatorPage data-id="element-75" data-mp="3ahxggruxls8l" />} data-id="element-74" data-mp="3fjmtue5mmhzu" />
            <Route path="/contact-us" element={<ContactUs data-id="element-77" data-mp="3aks0wjdy3d20" />} data-id="element-76" data-mp="3aiz0hltxdp2g" />
            <Route path="/about-us" element={<AboutUs data-id="element-79" data-mp="35q5wj06a6krf" />} data-id="element-78" data-mp="35r7bvgubxtey" />
            <Route path="/faq" element={<FAQPage data-id="element-81" data-mp="31qdocoksugml" />} data-id="element-80" data-mp="35pcmnqc0zf52" />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-83" data-mp="31o14u6ze7y7f" />} data-id="element-82" data-mp="31p2k6nnfz6uy" />
            <Route path="/terms-conditions" element={<TermsConditionsPage data-id="element-85" data-mp="246vfckiv23n" />} data-id="element-84" data-mp="235ljbf8slni" />
            <Route path="/return-policy" element={<ReturnPolicyPage data-id="element-87" data-mp="3tg8lv8it9cmc" />} data-id="element-86" data-mp="3thbdxjrvdl3u" />
            <Route path="/shipping-policy" element={<ShippingPolicyPage data-id="element-89" data-mp="h07katxnfkgs" />} data-id="element-88" data-mp="3tg05h6nhbp6e" />
            <Route path="/report-issue" element={<ReportIssuePage data-id="element-91" data-mp="gy37tnlopd4w" />} data-id="element-90" data-mp="gz62m6m4nzq3" />
            <Route path="/help-center" element={<HelpCenterPage data-id="element-93" data-mp="ls7gqceifv8m" />} data-id="element-92" data-mp="lqwewi4mkxk5" />
            <Route path="/track-order" element={<TrackOrderPage data-id="element-95" data-mp="72jixl5jfepn" />} data-id="element-94" data-mp="71rwaztx4rbi" />
            <Route path="/medicine-reminder" element={<MedicineReminderPage data-id="element-97" data-mp="c0l9er5amgb5" />} data-id="element-96" data-mp="73l4ijk6jjlm" />
            <Route path="/bundle-builder" element={<BundleBuilderPage data-id="element-99" data-mp="byi99eaff6sp" />} data-id="element-98" data-mp="c1mn73dp1gwk" />
            <Route path="/stacking-guide" element={<StackingGuidePage data-id="element-101" data-mp="zr75rl5xqc5b" />} data-id="element-100" data-mp="zq5tjdd6njm0" />
            <Route path="/quiz-results" element={<QuizResultsPage data-id="element-103" data-mp="14oh4xsj4m26c" />} data-id="element-102" data-mp="14p8ou63d2bgs" />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </>;
}